import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { NoRouteComponent } from '../../components/no-route/no-route.component';
import { CrowdinOtaService } from '../../../../services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from '../../../../services/language.service';
import { TranslationService } from '../../../../services/translation.service';

@Component({
    selector: 'app-provider-page',
    templateUrl: './provider-page.component.html',
    styleUrls: ['./provider-page.component.scss'],
    imports: [TranslateModule, NoRouteComponent],
    standalone: true
})
export class ProviderPageComponent implements OnInit {
  isNotFound: boolean = false;
  _language: any;
  translationData: any;
  content: string = 'CP_PROVIDER_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService,
    private readonly _actRoute: ActivatedRoute,
    private readonly _crowdinService: CrowdinOtaService,
    private readonly languageService: LanguageService) {
    const langId = this.languageService.getLanguage();
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
    this._language = langId && this.languageService.checkIsValideLanguage(langId) ? langId :
    (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
      localStorage.setItem('language', this._language);
  }
  this._translationService.sharetranslationData.subscribe((data) => {
    this.translationData = data;
    this.isTranslationDone = true;
  });
  }

  ngOnInit(): void {
    this.content = 'CP_PROVIDER_TEMPLATE';

    const languageCode = this._language.split('-')[0];
    this._crowdinService.useLanguage(languageCode);
  }

}
